// extracted by mini-css-extract-plugin
module.exports = {"label":"heading-block_label__yVVlx","link":"heading-block_link__6UgKT","iconTip":"heading-block_iconTip__bxzP9"};